import * as yup from 'yup'

import { LegacyMoveModel } from './MovingContractModels'

class CustomerDetails {
  _id = ''
  firstName = ''
  lastName = ''
  altFirstName = ''
  altLastName = ''
  phone = ''
  phoneType = ''
  altPhone = ''
  altPhoneType = ''
  referredBy = ''
  notes = ''
  email = ''
  altEmail = ''
  isRepeat = false
  previousContractId = ''
  branchId = ''
  move: LegacyMoveModel = new LegacyMoveModel()
  status = ''
  nounce = ''
  externalId = ''
}

class CancelCustomerDetails {
  _id = ''
  reason = ''
  nounce = ''
}

const CustomerDetailsSchema = yup.object().shape({
  firstName: yup.string().required('This field is required'),
  lastName: yup.string().required('This field is required'),
  branchId: yup.string().required('This field is required'),
  email: yup.string().email('This field should be a valid email'),
  altEmail: yup.string().email('This field should be a valid email'),
  referredBy: yup.string().required('This field is required;'),
  isRepeat: yup.boolean(),
})

const CancelCustomerDetailsSchema = yup.object().shape({
  reason: yup.string(),
})

export { CancelCustomerDetails, CancelCustomerDetailsSchema, CustomerDetails, CustomerDetailsSchema }
